

export default {
  setCustomerData (state, customer) {
    if (customer.hasOwnProperty('id')) state.id = customer.id
    if (customer.hasOwnProperty('name')) state.name = customer.name
    if (customer.hasOwnProperty('max_users')) state.users = customer.max_users
    if (customer.hasOwnProperty('phone')) state.phone = customer.phone
    if (customer.hasOwnProperty('phoneExt')) state.phoneExt = customer.phoneExt
    if (customer.hasOwnProperty('fax')) state.fax = customer.fax
    if (customer.hasOwnProperty('faxExt')) state.faxExt = customer.faxExt
    if (customer.hasOwnProperty('website')) state.website = customer.website
    if (customer.hasOwnProperty('email')) state.email = customer.email
    if (customer.hasOwnProperty('created_at')) state.created_at = customer.created_at
    if (customer.hasOwnProperty('update_at')) state.update_at = customer.update_at
    if (customer.hasOwnProperty('inactive')) state.inactive = customer.inactive
    if (customer.hasOwnProperty('maintenance_mode')) state.maintenance_mode = !!customer.maintenance_mode
    if (customer.hasOwnProperty('hasPowerPoints')) state.hasPowerPoints = customer.hasPowerPoints
    if (customer.hasOwnProperty('hasReferenceFiles')) state.hasReferenceFiles = customer.hasReferenceFiles
    if (customer.hasOwnProperty('hasFileSharing')) state.hasFileSharing = customer.hasFileSharing
    if (customer.hasOwnProperty('trend_categories')) state.trendCategories = customer.trend_categories
  },
  clearCustomerData (state) {
    state.id = null
    state.name = ''
    state.users = null
    state.phone = ''
    state.phoneExt = ''
    state.fax = ''
    state.faxExt = ''
    state.website = ''
    state.email = ''
    state.created_at = null
    state.updated_at = null
    state.inactive = null
    state.maintenance_mode = null
    state.hasPowerPoints = false
    state.hasReferenceFiles = false
    state.hasFileSharing = false
    state.trendCategories = null
  },
  setPowerPoints (state, value) {
    state.hasPowerPoints = value
  },
  setHasReferenceFiles (state, value) {
    state.hasReferenceFiles = value
  },
  setHasFileSharing (state, value) {
    state.hasFileSharing = value
  },
  setMaintenanceMode (state, value) {
    state.maintenance_mode = value
  },
}
